"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
const fonts = ['Abel', 'Anton', 'Archivo Narrow', 'Asap', 'Bree Serif', 'Crimson Text', 'Cuprum', 'Exo', 'Exo 2', 'Fira Sans', 'Francois One', 'Josefin Sans', 'Karla', 'Libre Baskerville', 'Merriweather Sans', 'Pacifico', 'Poiret One', 'Quicksand', 'Signika', 'Varela Round', 'Arvo', 'Bitter', 'Cabin', 'Catamaran', 'Dosis', 'Fjalla One', 'Hind', 'Inconsolata', 'Indie Flower', 'Lobster', 'Muli', 'Noto Serif', 'Nunito', 'Oxygen', 'PT Serif', 'Playfair Display', 'Poppins', 'Titillium Web', 'Ubuntu Condensed', 'Yanone Kaffeesatz', 'Baloo Bhai', 'David Libre', 'Droid Sans', 'Gidugu', 'Lalezar', 'Lato', 'Lora', 'Montserrat', 'Open Sans', 'Open Sans Condensed', 'Oswald', 'PT Sans', 'Raleway', 'Roboto', 'Roboto Condensed', 'Roboto Slab', 'Ruslan Display', 'Slabo 27px', 'Source Sans Pro', 'Ubuntu'];
const SelectFontFamily = props => /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, props, {
  className: "font-controls-family select col col-8 h5"
}), /*#__PURE__*/_react.default.createElement("option", {
  value: ""
}, "Selecione uma fonte"), fonts.map(font => /*#__PURE__*/_react.default.createElement("option", {
  key: font,
  value: font
}, font)));
var _default = exports.default = SelectFontFamily;